import { type Action } from '@reduxjs/toolkit';

import { type RequestFailedAction } from '../../admin-types';
import { isRequestFailed } from './request-failed/reducer';

export interface AsyncState {
  inProcess: boolean;
  updatedAt?: number;
  error?: string;
}

export const asyncStateInitial: AsyncState = {
  inProcess: false,
  updatedAt: undefined,
};

export function startLoading(state: { inProcess: boolean }): void {
  state.inProcess = true;
}

export function finishLoading(state: AsyncState): void {
  state.inProcess = false;
  state.updatedAt = Date.now();
}

export const requestFailedMatcher =
  (sliceName: string) =>
  (action: Action): action is RequestFailedAction =>
    isRequestFailed(action) &&
    action.payload.requestType.startsWith(`${sliceName}/`);

export function resetLoadingOnRequestFailed(state: {
  inProcess: boolean;
}): void {
  state.inProcess = false;
}
